module.exports = __webpack_public_path__ + "static/hhrefrigde-4db6cbb7f2b1e61fa33546120c4344ed.jpg";